module.exports = __webpack_public_path__ + "img/head_finance_1.b031c963.png";